import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex" };
const _hoisted_2 = { class: "grow font-semibold text-body text-foreground leading-none mb-[0.15rem]" };
const _hoisted_3 = { class: "title" };
const _hoisted_4 = { class: "text-en-blue-400 mt-[5px] leading-none font-normal" };
const _hoisted_5 = { class: "ml-[32px]" };
const _hoisted_6 = { class: "notification-message" };
const _hoisted_7 = ["href"];
const _hoisted_8 = { class: "flex w-fit ml-[32px] cursor-default opacity-60" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnItem"], {
        class: _normalizeClass(`notification-list-item-container type-${$setup.notificationType} border-b-1 rounded-none p-0 py-3`)
    }, {
        header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["rounded-[0.44rem] mr-2 w-[24px] h-[24px]", {
                            'text-blue-600': $setup.notificationType === 'info',
                            'text-yellow-600': $setup.notificationType === 'warning',
                            'text-red-600': $setup.notificationType === 'error'
                        }])
                }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent($setup.icon), { size: 20 }))
                ], 2 /* CLASS */),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString($props.item?.title || $props.item?.type), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_4, _toDisplayString($setup.formattedTime), 1 /* TEXT */)
                ]),
                ($props.canBeRead)
                    ? (_openBlock(), _createBlock($setup["EnButton"], {
                        key: 0,
                        variant: "ghost",
                        size: "icon-sm",
                        class: "mark-as-read-button size-6",
                        onClick: $setup.handleOnNotificationRead
                    }, {
                        default: _withCtx(() => [
                            _createVNode($setup["X"])
                        ]),
                        _: 1 /* STABLE */
                    }))
                    : _createCommentVNode("v-if", true)
            ])
        ]),
        footer: _withCtx(() => [
            ($props.item?.url && $props.item.triggerDownload)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: $props.item?.url,
                    class: "flex w-initial ml-[32px] text-foreground hover:no-underline text-primary"
                }, [
                    _createVNode($setup["EnButton"], {
                        variant: "secondary",
                        size: "sm"
                    }, {
                        default: _withCtx(() => [
                            _createVNode($setup["EnExportIcon"]),
                            _createElementVNode("span", null, _toDisplayString($setup.t('common.notifications.downloadFiles')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ], 8 /* PROPS */, _hoisted_7))
                : ($props.item?.url)
                    ? (_openBlock(), _createBlock($setup["EnTooltip"], {
                        key: 1,
                        text: $setup.t('notifications.obsoleteUrl'),
                        position: "bottom"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode($setup["EnButton"], {
                                    variant: "secondary",
                                    size: "sm"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode($setup["EnExportIcon"]),
                                        _createElementVNode("span", null, _toDisplayString($setup.t('common.notifications.downloadFiles')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["text"]))
                    : _createCommentVNode("v-if", true)
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString($props.item?.message), 1 /* TEXT */)
            ])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class"]));
}
